import React, { Component } from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl
} from "react-bootstrap";

export default class Create extends Component {
    render () {
        let {
            actions,
            
            cardType
        } = this.props;

        return (
            <div>
                <FormGroup>
                    <ControlLabel>Card Type</ControlLabel>
                    <FormControl
                        value={cardType}
                        onChange={(e) => {
                            actions.setValue({
                                cardType: e.target.value
                            });
                        }}
                    />
                </FormGroup>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/EVoucherCardType/FormContainer/Create.js